import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Picked/QA stats',
  description: 'Displays picked and/or QA:d orders and boxes for selected period'
};



// WEBPACK FOOTER //
// ./app/widgets.new/PickQaStats/index.js